import { getOdinData as  odinRequest} from 'msfe-client-request'
import { getEnvironment } from '@/env.js';

const domainMap = {
    'test': '//test-odin.sohu.com/odin',
    'pre': '//pre-odin.sohu.com/odin',
    'prod': '//odin.sohu.com/odin',
}
/**
 * @description 空广告上报
 * @param {*} data 
 */
const handleEmptyAdReport = (data) => {
    if(data?.adExt?.reportUrlList?.length){
        window.MptcfePcAdver?.handlerAdExt(data.adExt)
    }
}

/**
 * @description 文章页客户端奥丁请求
 * @param {*} param 
 * @returns 
 */
export const getOdinData = async function (param) {
    if(!param) {
        console.log('奥丁请求未传参，请检查传参', param)
        return
    }
    const { env = getEnvironment() } = param 
    const pcArticleInfo = window.pcArticleInfo || {}
    const mainContent = {
        productId: '',
        productType: '',
        secureScore: pcArticleInfo?.secureScore || 100,
        categoryId: pcArticleInfo?.channel_id || '',
        authorId: pcArticleInfo?.media_id || '',
        articleId: pcArticleInfo?.news_id || ''
    }
    const requestParam = {
        env,
        url: domainMap[env] + '/api/a/blockdata?origin=article', // 推荐阅读灰度后去掉拼接参数
        mainContent,
        param,
        isBatch: param?.isBatch
    }
    const result = await odinRequest(requestParam)
    handleEmptyAdReport(result)
    return result
}
// 格式化奥丁数据
export const formatOdinData = function(data){
    try {
        let { backups,list } = data
        const array = []
        for(let i = 0; i < list.length; i++){
            let item = list[i]
            const resourceData = item.resourceData || {}
            const resourceType = item.resourceType
            if(resourceType==3 || resourceType==2) {// 广告+推广
                const backupContent = backups?.[item.position-1] || {} // 打底内容
                const adResult = {
                    ...resourceData,
                    id: resourceData?.id || String(new Date().getTime()).slice(-4) + '_' + i,
                    type: resourceData?.adType,
                    resourceType: resourceType,
                    replaced: {
                        ...backupContent
                    },
                    position: i,
                    location: item.position,
                    backup: resourceData.backUp,
                    randomId: Math.random().toString(30).slice(6) + '_',
                }
                array.push(adResult)
            }else {
                item.resourceType = 1
                item.type = item?.contentType
                item.images = item.cover || []
                item.position = i
                item.mobileTitle = item.title
                item.mobilePersonalPage = item.authorHomePage
                item.authorId = item.authorId
                item.authorPic = item.authorCover
                item.publicTime = item.postTime
                item.personalPage = item.authorHomePage
                array.push(item)
            }
        }
        return array
    } catch (error) {
        console.log('format odin ',error)
        return []
    }
}